import { uiActions } from '../ui-slice';
import { form4Actions } from './form4-slice';
import { doNavigation } from '../../utils/helper-functions';

export const form4Transaction = (
  values,
  currentStep,
  navigateHook,
) => {
  return (dispatch) => {
    dispatch(uiActions.setLoaderStatus({ type: 'simple' }));
    dispatch(form4Actions.setFormData(values));
    doNavigation(currentStep, 'forward', navigateHook, dispatch, true);
  };
};
